import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['slugText', 'orderText', 'activeText', 'idText', 'manageGroupForm', 'searchText', 'membershipText'];

  update(e) {
    const key = e.target.value;

    const id = document.getElementsByName(`id-${key}`);
    const slug = document.getElementsByName(`slug-${key}`);
    const order = document.getElementsByName(`orderIdx-${key}`);
    const active = document.getElementsByName(`radio-${key}`);
    const membership = document.getElementsByName(`membership-${key}`);
    const search = document.getElementsByName('search');

    this.idTextTarget.value = id[0].value;
    this.slugTextTarget.value = slug[0].value;
    this.orderTextTarget.value = order[0].value;
    this.activeTextTarget.value = active[0].checked ? 1 : 0;
    this.membershipTextTarget.value = membership[0].checked ? 1 : 0;
    this.searchTextTarget.value = search[0].value;
    this.manageGroupFormTarget.submit();
  }
}
